exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".tags-decorations .stripe+.stripe{margin-left:.5rem}", ""]);

